function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Alert");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20.9484821 0 20.9484821 19.9919554 0 19.9919554"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Alert",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.52559821,10.8315982 L11.4005982,10.8315982 L11.4005982,5.1173125 L9.52559821,5.1173125 L9.52559821,10.8315982 Z M9.52559821,14.5815982 L11.4005982,14.5815982 L11.4005982,12.7065982 L9.52559821,12.7065982 L9.52559821,14.5815982 Z M20.9485446,9.89409821 L18.6697054,7.2954375 L19.0143482,3.71883036 L15.3077411,2.86258036 L13.6119375,-8.92857143e-06 L10.3497946,1.39400893 L7.22470536,0.0277589286 L5.4313125,2.99865179 L2.07488393,3.74124107 L2.37452679,7.18624107 L-2.67857143e-05,9.89409821 L2.33899107,12.5613304 L2.01184821,15.9562411 L5.19291964,16.6911518 L7.10015179,19.9107054 L10.2784554,18.5526696 L13.5706875,19.9919554 L15.4259554,16.9187411 L18.9629196,16.1361518 L18.6480982,12.5173125 L20.9485446,9.89409821 Z",
  id: "Fill-1",
  fill: "#EE4438",
  mask: "url(#mask-2)"
})));

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.120f75c7.svg";
export { ForwardRef as ReactComponent };